module.exports = __webpack_public_path__ + "static/scale-model-of-ybor-city-center-fountain-in-tampa-florida-79ecba95abc7191b48b658e1eb87e640.png";